import { createContext, useContext } from 'react'

export interface TelegramContextType {
  // Init data
  initData: any
  getInitDataRaw: () => string
  user: any
  launchParams: any

  // Theme
  themeParams: any
  isDark: boolean
  bgColor: string
  textColor: string
  buttonColor: string
  buttonTextColor: string
  secondaryBgColor: string
  hintColor: string
  linkColor: string

  // Viewport
  viewport: any
  viewportHeight: number
  viewportStableHeight: number
  isExpanded: boolean

  // Haptic
  impactHaptic: (style?: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void
  notificationHaptic: (type?: 'error' | 'success' | 'warning') => void
  selectionHaptic: () => void

  // Main button
  showMainButton: (text: string, onClick: () => void) => void
  hideMainButton: () => void
  setMainButtonLoading: (loading: boolean) => void
  mainButton: any

  // Back button
  showBackButton: (onClick: () => void) => void
  hideBackButton: () => void
  backButton: any

  // Popup
  showAlert: (message: string) => void
  showConfirm: (message: string) => Promise<boolean>
  popup: any

  // Links
  /**
   * По умолчанию — встроенный браузер Telegram. `external: true` открывает в
   * системном браузере: там есть адресная строка и общие с почтой куки.
   * Нужно для чужих логинов (#419: сброс пароля FatSecret во встроенном
   * браузере заканчивался «ссылка недействительна», а скопировать её оттуда
   * нельзя — адресной строки нет).
   */
  openLink: (url: string, opts?: { external?: boolean }) => void
  // Открывает t.me-ссылку внутри Telegram (чат с ботом и т.п.) и закрывает Mini App
  openTelegramLink: (url: string) => void

  // App
  ready: () => void
  close: () => void
  miniApp: any
}

const noop = () => {}

const defaultContext: TelegramContextType = {
  initData: undefined,
  getInitDataRaw: () => '',
  user: undefined,
  launchParams: undefined,

  themeParams: undefined,
  isDark: false,
  bgColor: '#ffffff',
  textColor: '#000000',
  buttonColor: '#3390ec',
  buttonTextColor: '#ffffff',
  secondaryBgColor: '#f0f0f0',
  hintColor: '#999999',
  linkColor: '#3390ec',

  viewport: undefined,
  viewportHeight: window.innerHeight,
  viewportStableHeight: window.innerHeight,
  isExpanded: true,

  impactHaptic: noop,
  notificationHaptic: noop,
  selectionHaptic: noop,

  showMainButton: noop,
  hideMainButton: noop,
  setMainButtonLoading: noop,
  mainButton: undefined,

  showBackButton: noop,
  hideBackButton: noop,
  backButton: undefined,

  showAlert: (message: string) => alert(message),
  showConfirm: async (message: string) => confirm(message),
  popup: undefined,

  openLink: (url: string, _opts?: { external?: boolean }) => window.open(url, '_blank'),
  openTelegramLink: (url: string) => window.open(url, '_blank'),

  ready: noop,
  close: () => window.close(),
  miniApp: undefined,
}

export const TelegramCtx = createContext<TelegramContextType>(defaultContext)

export function useTelegram(): TelegramContextType {
  return useContext(TelegramCtx)
}

export type { TelegramContextType as TelegramContext }
